import React, { SVGProps } from "react";

export default function SupVault(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5496 9.6C11.4049 9.03776 10.9622 8.59512 10.4 8.45041V7.6H9.6V8.45041C9.03776 8.59512 8.59512 9.03776 8.45041 9.6H7.6V10.4H8.45041C8.59512 10.9622 9.03776 11.4049 9.6 11.5496V12.4H10.4V11.5496C10.9622 11.4049 11.4049 10.9622 11.5496 10.4H12.4V9.6H11.5496ZM10.8 10C10.8 10.4418 10.4418 10.8 10 10.8C9.55817 10.8 9.2 10.4418 9.2 10C9.2 9.55817 9.55817 9.2 10 9.2C10.4418 9.2 10.8 9.55817 10.8 10Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.4 5.2C6.63269 5.2 5.2 6.63269 5.2 8.4V11.6C5.2 13.3673 6.63269 14.8 8.4 14.8H11.6C13.3673 14.8 14.8 13.3673 14.8 11.6V5.2H8.4ZM14 6H8.4C7.07452 6 6 7.07452 6 8.4V11.6C6 12.9255 7.07452 14 8.4 14H11.6C12.9255 14 14 12.9255 14 11.6V6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.2 2C3.43269 2 2 3.43269 2 5.2V14.8C2 16.5673 3.43269 18 5.2 18H14.8C16.5673 18 18 16.5673 18 14.8V2H5.2ZM17.2 2.8H5.2C3.87452 2.8 2.8 3.87452 2.8 5.2V14.8C2.8 16.1255 3.87452 17.2 5.2 17.2H14.8C16.1255 17.2 17.2 16.1255 17.2 14.8V2.8Z"
        fill="currentColor"
      />
    </svg>
  );
}
